export const TOAST_DURATION = 5;
export const TOAST_STATUS = {
  critical: 'critical',
  info: 'info',
  success: 'success',
  warning: 'warning',
};
